module.exports = __webpack_public_path__ + "img/Slide49.526958ed.png";